import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as detailsActions from './details-actions';
import * as searchActions from "@app/marketplace/products/state/product-search/search-actions";
import * as relatedActions from "@app/marketplace/products/state/related-product/related-actions";
import { ProductService } from "../../_services/product.service";
import { catchError, withLatestFrom, map, switchMap, takeUntil, mergeMap } from "rxjs/operators";
import { of } from "rxjs";
import { Store } from "@ngrx/store";
import * as routerSelectors from '../../../route/router-state.selectors';
import * as locationSelectors from '../../../locations/state/locations-selectors';
import * as searchSelectors from '../../../products/state/product-search/search-selectors';
import { Utils } from "@app/marketplace/core/helpers/utils";

@Injectable()
export class ProductsDetailsEffects {
  constructor(
    private actions$: Actions,
    private service: ProductService,
    private store: Store<any>,) { }

    getProductDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(detailsActions.LOADING_PRODUCT_DETAILS, detailsActions.CANCEL_PRODUCTS_DETAILS_REQUEST),
      withLatestFrom(
        this.store.select(routerSelectors.getMergedRoute),
        this.store.select(locationSelectors.selectLocation),
        this.store.select(searchSelectors.selectProvider),
        (action: any, router: any, location: any, provider: any) => {
          return {
            action,
            params: router.params,
            location: { type: location.locationType, codes: location.locations },
            provider: provider,
          }
        }
      ),
      switchMap(data => {
        var payload = {
          code:data.params["code"],
          provider:Utils.GetProvider(data.params["provider"]),
          location: 0,
          locationResolver: false,
          searchTerms: ""
        };
        //this.store.dispatch(searchActions.SetProvider({provider:payload.provider}));
        if (data.location.codes.length > 0 && data.location.type === 0)
          payload.location = data.location.codes[0];


       /*  return this.service.GetProductDetail(payload).pipe(
          takeUntil(this.actions$.pipe(ofType(detailsActions.CANCEL_PRODUCTS_DETAILS_REQUEST))),
          map((data: any) => {
            if(data?.data?.provider)
              this.store.dispatch(searchActions.SetProvider({provider:data?.data?.provider}));
            this.processVariations(data);
            return { type: detailsActions.GET_PRODUCT_DETAILS, data };
          }),
          catchError((error) => of({ type: detailsActions.ERROR_PRODUCTS_DETAILS }))
        ); */

        return this.service.GetProductDetail(payload).pipe(
          takeUntil(this.actions$.pipe(ofType(detailsActions.CANCEL_PRODUCTS_DETAILS_REQUEST))),
          mergeMap((data: any) => {
            if(data?.data?.provider)
              this.store.dispatch(searchActions.SetProvider({provider:data?.data?.provider}));
            this.processVariations(data);
            if(data?.success){
              if(payload.provider>0){
                return [
                  { type: detailsActions.GET_PRODUCT_DETAILS, data },
                  { type: relatedActions.LOADING_RELATED_PRODUCTS, payload:{
                    searchTerms:data?.data?.name,
                    productCode: data?.data?.code,
                    ProductProvider:payload.provider
                  }}
                ]
              }
              else{
                return [
                  { type: detailsActions.GET_PRODUCT_DETAILS, data },
                ]
              }

            }
            else return [{type: detailsActions.GET_PRODUCT_DETAILS, data }]

          }),
          catchError((error) => of({ type: detailsActions.ERROR_PRODUCTS_DETAILS }))
        );

      })
    )
  );

  getProductDetailsDlg$ = createEffect(() =>
    this.actions$.pipe(
      ofType(detailsActions.LOADING_PRODUCT_DETAILS_DLG),
      withLatestFrom(
        this.store.select(locationSelectors.selectLocation),
        (action: any, location: any) => {
          return {
            action,
            location: { type: location.locationType, codes: location.locations }
          }
        }
      ),
      switchMap(data => {
        var payload = {
          code:data.action.code,
          provider:data.action.provider,
          location: 0,
          locationResolver: false,
          searchTerms: ""
        };
        if (data.location.codes.length > 0 && data.location.type === 0)
          payload.location = data.location.codes[0];
        return this.service.GetProductDetail(payload).pipe(
          takeUntil(this.actions$.pipe(ofType(detailsActions.CANCEL_PRODUCTS_DETAILS_REQUEST))),
          map((data: any) => {
            if(data?.data?.provider)
              this.store.dispatch(searchActions.SetProvider({provider:data?.data?.provider}));
              this.processVariations(data);
            return { type: detailsActions.GET_PRODUCT_DETAILS, data };
          }),
          catchError((error) => of({ type: detailsActions.ERROR_PRODUCTS_DETAILS }))
        );
      })
    )
  );

  public getKey(index: any, value: any, currents: any) {
    let key = "";
    if (currents?.length > 0) {
      currents.map(function (v, i) {
        if (index === i)
          key = key ? `${key}${i}${value}` : `${i}${value}`;
        else
          key = key ? `${key}${i}${v.value}` : `${i}${v.value}`;
      })
    }
    return key;
  }
  private processVariations(response: any) {
    //set combinations key
    response?.data?.variations?.combinations?.forEach(function (val1) {
      val1.combination.map(function (val2) {
        val1.key = val1.key ? `${val1.key}${val2.index}${val2.value}` : `${val2.index}${val2.value}`;
      })
    });
    //set current Key
    if (response?.data?.variations) {
      response?.data?.variations?.currentCombination?.map(function (val3) {
        if (response.data.variations.currentKey)
          response.data.variations.currentKey = `${response.data.variations.currentKey}${val3.index}${val3.value}`;
        else
          response.data.variations.currentKey = `${val3.index}${val3.value}`;
      })
    }
    //set dimension Key
     if (response?.data?.variations?.dimensions) {
      response.data.variations.dimensions.map(function (val4) {
        val4.data.map(function (val5) {
          if(val5.value==-1) return;
          let key = "";
          let currents= response.data.variations.currentCombination??[];
          let combinations= response?.data?.variations?.combinations;
          currents.map(function (v, i) {
            if (val4.index === i)
              key = key ? `${key}${i}${val5.value}` : `${i}${val5.value}`;
            else
              key = key ? `${key}${i}${v.value}` : `${i}${v.value}`;
          });
          val5.key=key;
          val5.product=combinations.find(i => i.key === key)?.productCode??"";
        })
      })
    }
  }

  /* getProductDetails$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        filter((r: RouterNavigatedAction) => {
          return r.payload.routerState.url.startsWith('/market/productos-compras-cuba-online/details');
        }),
        map((r: RouterNavigatedAction) => {
          return {
            code: r.payload.routerState['params']['code'],
            location: r.payload.routerState['params']['location']
          }
        }),
        switchMap(payload => {
          var newPayload = {
            code: payload.code,
            location: payload.location,
            locationResolver: false,
            searchTerms: "",
          };
          return this.service.GetProductDetail(newPayload).pipe(
            takeUntil(this.actions$.pipe(ofType(detailsActions.CANCEL_PRODUCTS_DETAILS_REQUEST))),
            map((data: any) => {
              return { type: detailsActions.GET_PRODUCT_DETAILS, data };
            }),
            catchError((error) => of({ type: detailsActions.ERROR_PRODUCTS_DETAILS }))
          );
        })
      )
    ); */
}
